export const OURWORKS_EMPLOYEE_API =  "ourWorks";
export const OURWORKS_ASSETS_API = 'ourWorks/assets';